import type { ContactPayload } from "@holigral/shared/contact"
import { baseApi } from "@/base"

const api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    submitContact: build.mutation<void, ContactPayload>({
      query: (body) => ({
        url: "contact",
        method: "POST",
        body,
      }),
      extraOptions: { withoutAuth: true },
    }),
  }),
})

export const { useSubmitContactMutation } = api
